import { usePkce } from '@oliasoft/pkce';
import httpClient from '~utils/httpClient';

export default function useLogout(): () => Promise<void> {
  const auth = usePkce();

  const apiLogout = async () => httpClient({
    method: 'get',
    url: '/api/logout',
    baseURL: '/',
  });

  const handleLogout = async () => {
    await apiLogout();
    localStorage.clear();
    await auth.logout();
  };

  return handleLogout;
}
